class HighlightsSection extends HTMLElement {
  constructor() {
    super();
    this.slideEl = this.querySelector(".swiper");
    this.desktopThumbs = this.querySelectorAll("[data-thumb-index]");

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        cssMode: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };

      this.swiper = new Swiper(this.slideEl, swiperParams);

      this.animateTimeout = null;

      this.swiper.on("slideChange", () => {
        clearTimeout(this.animateTimeout);
        const index = this.swiper.realIndex;
        this.desktopThumbs.forEach((thumb) => {
          thumb.classList.remove("active");
        });

        this.animateTimeout = setTimeout(() => {
          this.desktopThumbs[index].classList.add("active");
        }, 100);
      });
    });
  }

  connectedCallback() {
    this.changeTimeout = null;

    this.desktopThumbs.forEach((thumb) => {
      thumb.addEventListener("mouseenter", (e) => {
        clearTimeout(this.changeTimeout);
        const index = thumb.getAttribute("data-thumb-index");

        this.changeTimeout = setTimeout(() => {
          this.swiper.slideTo(index, 0);
        }, 300);
      });

      thumb.addEventListener("click", (e) => {
        clearTimeout(this.changeTimeout);
        const index = thumb.getAttribute("data-thumb-index");

        this.changeTimeout = setTimeout(() => {
          this.swiper.slideTo(index, 0);
        }, 300);
      });
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("highlights-section")) {
  customElements.define("highlights-section", HighlightsSection);
}
